import { GET_TAG,GET_TAG_MASTER,GET_POS,GET_POS_REASONS_WITH_MATERIAL,GET_POS_EMP_DATA, REQUIRED_DOCUMENTS, SAVE_COMPETITON_MAPPING, COMPETITION_MAPPING_DATA, FETCH_SITE_NAME} from "./type";

const initalState = {
  materialData: [],
  posRequirement: [],
  posReasonAndMaterials: [],
  posEmployeeData: [],
  requiredDocumentsDropdown: [],
  saveCompetitonMappingResponse: [],
  competititonMappingResponse: [],
  fetchSiteNameResponse: []
};

const tagDeliveryReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TAG:
      return {
        ...state,
        tagData: payload,
      };
    case GET_TAG_MASTER:
    return {
      ...state,
      tags: payload,
    };
    case GET_POS:
    return {
      ...state,
      posRequirement: payload,
    };
    case GET_POS_REASONS_WITH_MATERIAL:
    return {
      ...state,
      posReasonAndMaterials: payload,
    };
    case GET_POS_EMP_DATA:
    return {
      ...state,
      posEmployeeData: payload,
    };
    case REQUIRED_DOCUMENTS:
      return {
        ...state,
        requiredDocumentsDropdown: payload,
      };
    case SAVE_COMPETITON_MAPPING:
      return {
        ...state,
        saveCompetitonMappingResponse: payload,
      };
    case COMPETITION_MAPPING_DATA:
      return {
        ...state,
        competititonMappingResponse: payload,
      };
    case FETCH_SITE_NAME:
      return {
        ...state,
        fetchSiteNameResponse: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default tagDeliveryReducer;
